<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div class="flex flex-col">
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Motivos para visitas a clientes.
                Ej.: usalo para definir los motivos
                de gastos y sus configuraciones.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Motivos de gastos
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina los motivos de <b>gastos</b>.
        </div>
      </div>
      <div class="flex items-center space-x-2">
        <app-status-filters [selectedStatuses]="selectedStatuses" 
                [showStatus]="[1,0]"
                (selectionFilterApply)="findAllWithCount()">
        </app-status-filters>

        <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort [trackBy]="trackByFn">
              <!-- Nombre -->
               <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
                <td mat-cell *matCellDef="let expense" class="text-sm uppercase leading-tight">
                  {{ expense.name }}
                </td>
              </ng-container>

              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto permitido {{ 'code' | companyCurrency: true }}</th>
                <td mat-cell *matCellDef="let expense" class="text-sm uppercase leading-tight">
                  {{ expense.maximumAmountAllowed }}
                </td>
              </ng-container>

              <ng-container matColumnDef="photographRequired">
                <th mat-header-cell *matHeaderCellDef>Requiere Foto</th>
                <td mat-cell *matCellDef="let expense">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="expense.photographRequired == true"
                    [(ngModel)]="expense.photographRequired" [color]="'success'"
                    (ngModelChange)="onPhotoChange($event, expense)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <ng-container matColumnDef="observationRequired">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Requiere observación</th>
                <td mat-cell *matCellDef="let expense" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="expense.observationRequired == 1"
                    [(ngModel)]="expense.observationRequired" [color]="'success'"
                    (ngModelChange)="onObservationChange($event, expense)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Estado</th>
                <td mat-cell *matCellDef="let expense" class="px-6 text-left">
                  <mat-slide-toggle class="custom-slide-toggle primary" [checked]="expense.statusId == 1"
                    [(ngModel)]="expense.statusId" [color]="'success'"
                    (ngModelChange)="onStatusChange($event, expense)">
                  </mat-slide-toggle>
                </td>
              </ng-container>

              <!-- Acciones -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
                <td mat-cell *matCellDef="let expense" class="px-6 py-3 text-left">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button mat-menu-item (click)="openEditModal(expense)">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar Registro</span>
                    </button>
                    <button mat-menu-item (click)="openDeleteDialog(expense)">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Eliminar Registro</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10 bg-white dark:bg-gray-900"></tr>

              <!-- Fila principal -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b h-16"></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="onPageChange($event)"></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro de Razón de Gasto</h2>

      <mat-dialog-content class="modal-content" [formGroup]="createForm">

        <mat-tab-group>
          <mat-tab label="Datos Generales">
            <div class="flex gap-4 items-start">

              <mat-form-field appearance="fill" class="w-1/2 flex-shrink-0">
                <mat-label>Nombre</mat-label>
                <input matInput type="text" formControlName="name" required>
                <mat-error *ngIf="createForm?.get('name')?.hasError('required')">
                  Nombre requerido.
                </mat-error>
              </mat-form-field>

              <div class="flex flex-col gap-3 mt-2 w-1/2">
                <mat-slide-toggle color="primary" formControlName="statusId">
                  Estado
                </mat-slide-toggle>
              </div>
            </div>

            <mat-divider class="my-4"></mat-divider>

            <div class="flex gap-4 items-start">

              <mat-form-field appearance="fill" class="w-1/2 flex-shrink-0">
                <mat-label>Monto Máximo</mat-label>
                <input matInput type="number" formControlName="maximumAmountAllowed" required min="0">
                <mat-error *ngIf="createForm?.get('maximumAmountAllowed')?.hasError('required')">
                  Monto requerido.
                </mat-error>
              </mat-form-field>

              <div class="flex flex-col gap-3 mt-2 w-1/2">
                <mat-slide-toggle color="primary" formControlName="photographRequired">
                  ¿Fotografía Requerida?
                </mat-slide-toggle>

                <mat-slide-toggle color="primary" formControlName="observationRequired">
                  ¿Observación Requerida?
                </mat-slide-toggle>
              </div>
            </div>

            <mat-divider class="my-4"></mat-divider>
            <div class="grid grid-cols-2 gap-4 items-center">

              <div class="flex items-center h-full">
                <mat-slide-toggle color="accent" formControlName="allSubRoutesBySalesOffices">
                  Aplicar a todas las Rutas de las Oficinas seleccionadas
                </mat-slide-toggle>
              </div>

              <mat-form-field *ngIf="!createForm?.get('allSubRoutesBySalesOffices')?.value" appearance="fill"
                class="w-full">
                <mat-label>Ruta(s)</mat-label>
                <mat-select formControlName="subRoutesBySalesOffices" multiple placeholder="Seleccione Ruta(s)"
                  panelClass="select-panel-with-search">

                  <mat-select-trigger>
                    {{ getDisplayValueForMongoId(routeList, createForm.get('subRoutesBySalesOffices')?.value, "name")}}
                  </mat-select-trigger>

                  <mat-option disabled>
                    <ngx-mat-select-search [(ngModel)]="routeSearch" [ngModelOptions]="{ standalone: true }"
                      placeholderLabel="Buscar Ruta..." noEntriesFoundLabel="No se encontraron resultados"
                      (ngModelChange)="filteredRoutesList($event)">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let type of filteredRouteList" [value]="type._id">
                    {{ type.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </mat-tab>
          <mat-tab label="Oficinas de venta">
            <div class="flex items-center justify-between gap-4">
              <mat-slide-toggle color="accent" formControlName="allSalesOffices"
              (change)="deleteDataSource()">
                Aplicar a todas las Oficinas de Venta
              </mat-slide-toggle>

              <button mat-flat-button color="primary" type="button" (click)="addSaleOfficeRow()"
                *ngIf="!createForm?.get('allSalesOffices')?.value">
                <mat-icon>add</mat-icon> Añadir Oficina
              </button>
            </div>

            <div *ngIf="!createForm?.get('allSalesOffices')?.value"
              class="mat-elevation-z2 mt-3 w-full overflow-x-auto">

              <table mat-table [dataSource]="dataSourceSalesOffice" class="w-full">

                <ng-container matColumnDef="salesOffice">
                  <th mat-header-cell *matHeaderCellDef> Oficina de Venta </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <mat-select formControlName="salesOfficesId" required>
                        <mat-option *ngFor="let office of salesOfficeList" [value]="office._id">
                          {{ office.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="element?.get('salesOfficesId')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="account">
                  <th mat-header-cell *matHeaderCellDef> Cuenta Contable </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <input matInput formControlName="account" required>
                      <mat-error *ngIf="element?.get('account')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="costCenter">
                  <th mat-header-cell *matHeaderCellDef> Centro de Costos </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <input matInput formControlName="costCenter" required>
                      <mat-error *ngIf="element?.get('costCenter')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="postingKey">
                  <th mat-header-cell *matHeaderCellDef> Clave Cont. </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <input matInput formControlName="postingKey" required>
                      <mat-error *ngIf="element?.get('postingKey')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button color="warn" (click)="removeSaleOfficeRow(i)" type="button">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnSalesOffice"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnSalesOffice;"></tr>

                <tr class="mat-row text-center" *matNoDataRow>
                  <td class="mat-cell" colspan="5">Añade al menos una oficina de venta.</td>
                </tr>

              </table>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createExpenseReason()"
          [disabled]="!createForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Actualizar Razón de Gasto</h2>

      <mat-dialog-content class="modal-content" [formGroup]="updateForm">
        <mat-tab-group>
          <mat-tab label="Datos Generales">
            <div class="flex gap-4 items-start">

              <mat-form-field appearance="fill" class="w-1/2 flex-shrink-0">
                <mat-label>Nombre</mat-label>
                <input matInput type="text" formControlName="name" required>
                <mat-error *ngIf="updateForm?.get('name')?.hasError('required')">
                  Nombre requerido.
                </mat-error>
              </mat-form-field>

              <div class="flex flex-col gap-3 mt-2 w-1/2">
                <mat-slide-toggle color="primary" formControlName="statusId">
                  Estado
                </mat-slide-toggle>
              </div>
            </div>

            <mat-divider class="my-4"></mat-divider>

            <div class="flex gap-4 items-start">

              <mat-form-field appearance="fill" class="w-1/2 flex-shrink-0">
                <mat-label>Monto Máximo</mat-label>
                <input matInput type="number" formControlName="maximumAmountAllowed" required min="0">
                <mat-error *ngIf="updateForm?.get('maximumAmountAllowed')?.hasError('required')">
                  Monto requerido.
                </mat-error>
              </mat-form-field>

              <div class="flex flex-col gap-3 mt-2 w-1/2">
                <mat-slide-toggle color="primary" formControlName="photographRequired">
                  ¿Fotografía Requerida?
                </mat-slide-toggle>

                <mat-slide-toggle color="primary" formControlName="observationRequired">
                  ¿Observación Requerida?
                </mat-slide-toggle>
              </div>
            </div>

            <mat-divider class="my-4"></mat-divider>

            <div class="grid grid-cols-2 gap-4 items-center">

              <div class="flex items-center h-full">
                <mat-slide-toggle color="accent" formControlName="allSubRoutesBySalesOffices">
                  Aplicar a todas las Rutas de las Oficinas seleccionadas
                </mat-slide-toggle>
              </div>

              <mat-form-field *ngIf="!updateForm?.get('allSubRoutesBySalesOffices')?.value" appearance="fill"
                class="w-full">
                <mat-label>Ruta(s)</mat-label>
                <mat-select formControlName="subRoutesBySalesOffices" multiple placeholder="Seleccione Ruta(s)"
                  panelClass="select-panel-with-search">

                  <mat-select-trigger>
                    {{ getDisplayValueForMongoId(routeList, updateForm.get('subRoutesBySalesOffices')?.value, "name")}}
                  </mat-select-trigger>

                  <mat-option disabled>
                    <ngx-mat-select-search [(ngModel)]="routeSearch" [ngModelOptions]="{ standalone: true }"
                      placeholderLabel="Buscar Ruta..." noEntriesFoundLabel="No se encontraron resultados"
                      (ngModelChange)="filteredRoutesList($event)">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let type of filteredRouteList" [value]="type._id">
                    {{ type.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-tab>
          <mat-tab label="Oficinas de venta">
            <div class="flex items-center justify-between gap-4">
              <mat-slide-toggle color="accent" formControlName="allSalesOffices">
                Aplicar a todas las Oficinas de Venta
              </mat-slide-toggle>

              <button mat-flat-button color="primary" type="button" (click)="addSaleOfficeRowToUpdate()"
                *ngIf="!updateForm?.get('allSalesOffices')?.value">
                <mat-icon>add</mat-icon> Añadir Oficina
              </button>
            </div>

            <div *ngIf="!updateForm?.get('allSalesOffices')?.value"
              class="mat-elevation-z2 mt-3 w-full overflow-x-auto">

              <table mat-table [dataSource]="dataSourceUpdateSalesOffice" class="w-full">
                <ng-container matColumnDef="salesOffice">
                  <th mat-header-cell *matHeaderCellDef> Oficina de Venta </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <mat-select formControlName="salesOfficesId" required>
                        <mat-option *ngFor="let office of salesOfficeList" [value]="office._id">
                          {{ office.name }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="element?.get('salesOfficesId')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="account">
                  <th mat-header-cell *matHeaderCellDef> Cuenta Contable </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <input matInput formControlName="account" required>
                      <mat-error *ngIf="element?.get('account')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="costCenter">
                  <th mat-header-cell *matHeaderCellDef> Centro de Costos </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <input matInput formControlName="costCenter" required>
                      <mat-error *ngIf="element?.get('costCenter')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="postingKey">
                  <th mat-header-cell *matHeaderCellDef> Clave Cont. </th>
                  <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                    <mat-form-field appearance="fill" class="w-full py-1 px-2">
                      <input matInput formControlName="postingKey" required>
                      <mat-error *ngIf="element?.get('postingKey')?.hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button mat-icon-button color="warn" (click)="removeSaleOfficeRowToUpdate(i)" type="button">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnSalesOffice"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnSalesOffice;"></tr>

                <tr class="mat-row text-center" *matNoDataRow>
                  <td class="mat-cell" colspan="5">Añade al menos una oficina de venta.</td>
                </tr>

              </table>
            </div>
          </mat-tab>
        </mat-tab-group>


      </mat-dialog-content>

      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="update()" [disabled]="!updateForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()">
    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="formFilter" [routeWithMongoId]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>
  </app-filter>

</mat-sidenav-container>